import * as Api from '@ViewModels';
import { ContactFilterCriteriaProperty, IContactFilterCriteria } from '@ViewModels';
import produce from 'immer';
import * as React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger } from '../../../../components/Select';
import { getCriteriaFromTab, PeopleSearchCriteria } from '../PeopleContext';
import { styleSheet } from './styles';

interface IProps {
	search: string;
	searchCriterion: PeopleSearchCriteria;
	filter: Api.IBulkContactsRequest;
	onFilterChange: (filter: Api.IBulkContactsRequest) => void;
}

export const PeopleSearchTypeSelect: React.FC<IProps> = ({ search, searchCriterion, filter, onFilterChange }) => {
	const handleSelect = (newSearchCriterion: PeopleSearchCriteria) => {
		const nextFilter = produce(filter, draftFilter => {
			const newCriteria = draftFilter.filter.criteria.filter(x => {
				return (
					x.property !== ContactFilterCriteriaProperty.All &&
					x.property !== ContactFilterCriteriaProperty.Company &&
					x.property !== ContactFilterCriteriaProperty.Name &&
					x.property !== ContactFilterCriteriaProperty.Tag
				);
			});

			const criterion: IContactFilterCriteria = {
				property: getCriteriaFromTab(newSearchCriterion),
			};
			if (search) {
				criterion.value = search;
			}

			newCriteria.push(criterion);
			draftFilter.filter.criteria = newCriteria;
		});
		onFilterChange(nextFilter);
	};

	const selectValue = {
		[ContactFilterCriteriaProperty.All]: 'All',
		[ContactFilterCriteriaProperty.Name]: 'Name',
		[ContactFilterCriteriaProperty.Tag]: 'Tag',
		[ContactFilterCriteriaProperty.Company]: 'Company',
	};

	return (
		<Select
			onValueChange={handleSelect as (value: string) => void}
			value={searchCriterion}
			defaultValue={selectValue[ContactFilterCriteriaProperty.All]}
		>
			<SelectTrigger styles={[styleSheet.selectTrigger]}>
				{searchCriterion !== selectValue[ContactFilterCriteriaProperty.All] ? searchCriterion : 'Search by'}
			</SelectTrigger>
			<SelectContent>
				<SelectItem value={selectValue[ContactFilterCriteriaProperty.All]}>
					{selectValue[ContactFilterCriteriaProperty.All]}
				</SelectItem>
				<SelectItem value={selectValue[ContactFilterCriteriaProperty.Name]}>
					{selectValue[ContactFilterCriteriaProperty.Name]}
				</SelectItem>
				<SelectItem value={selectValue[ContactFilterCriteriaProperty.Tag]}>
					{selectValue[ContactFilterCriteriaProperty.Tag]}
				</SelectItem>
				<SelectItem value={selectValue[ContactFilterCriteriaProperty.Company]}>
					{selectValue[ContactFilterCriteriaProperty.Company]}
				</SelectItem>
			</SelectContent>
		</Select>
	);
};
